export default __webpack_public_path__ + "static/media/ibank.d6f2695f.mp4";